import angular, { ILogService, IScope, ITimeoutService } from 'angular'
import { AccesoDatos } from 'src/_candidato/comun/services/acceso-datos'
import { IGrupoDoc } from 'src/_candidato/data/tiposStore'
import { NotificacionService } from 'src/_panel/module/uni-base/services/NotifService'
import { IEstadoCvStoreItem, IModelDocReq, IModelFormulario, IPregBusqueda } from 'src/model/candidato-api'
import { BusquedaCV } from '../../model/busqueda-cv'
import { ReglaReqDoc } from '../panel-doc-requirements/panel-doc-requirements.component'

class ReglaValidaReqDocComponentCtrl {
  reglaVal!: ReglaReqDoc

  estadosList: IEstadoCvStoreItem[]
  tiposDocGruposList: IGrupoDoc[]
  seleccionFormList: IModelFormulario[]

  dirty = false

  edit: {
    estado: string | null
    doc: string | null
    formid: number | null
    busqueda: BusquedaCV
    pregFilter: IPregBusqueda | null
  } = {
    estado: null,
    doc: null,
    formid: null,
    busqueda: null,
    pregFilter: null,
  }

  constructor(
    private $scope: IScope,
    private $element: JQLite,
    private $timeout: ITimeoutService,
    private $log: ILogService,
    private NotifService: NotificacionService,
    private AccesoDatos: AccesoDatos
  ) {
    this.edit.busqueda = new BusquedaCV()

    this.edit.busqueda.setMaxCondiciones(1)
  }

  $onInit(): void {
    this.$log.info('[ReglaValidaReqDocComponentCtrl] onInit')

    this.estadosList = this.reglaVal.estadosList
    this.tiposDocGruposList = this.reglaVal.tiposDocGruposList
    this.seleccionFormList = this.reglaVal.formsList

    if (this.reglaVal.rule.idreqdoc) {
      if (this.reglaVal.rule.estado) {
        this.edit.estado = this.reglaVal.rule.estado
      }

      if (this.reglaVal.rule.tipodoc) {
        this.edit.doc = this.reglaVal.rule.tipodoc
      }

      if (this.reglaVal.rule.idform) {
        this.edit.formid = this.reglaVal.rule.idform

        this.seleccionaForm(this.reglaVal.rule)
      }

      // si hay idquestion, definir la condición
    }
  }

  $postLink() {
    // this.$timeout(() => (this.$element.find('select') as any).formSelect(), 100)

    this.$timeout(() => {
      let textarea = this.$element.find('.materialize-textarea')

      if (textarea && textarea[0]) M.textareaAutoResize(textarea)
    }, 200)
  }

  update() {
    let rule = Object.assign({}, this.reglaVal.rule) as IModelDocReq

    rule.estado = this.edit.estado
    rule.tipodoc = this.edit.doc
    rule.idform = this.edit.formid

    if (this.edit.busqueda.condiciones.length) {
      this.edit.busqueda.condiciones[0].condicionToFilterReqDoc(rule)
    }

    this.AccesoDatos.Documentacion_CLIENT.actualizaReglaValidacionDocObligatoria(rule).then((ruleResponse) => {
      this.reglaVal.actualiza(ruleResponse)
      this.dirty = false
    })
  }

  cambioForm() {
    this.seleccionaForm()

    this.reglaVal.$dirty = true
  }

  seleccionaForm(rule?: IModelDocReq) {
    if (!this.edit.formid) return

    this.edit.busqueda.selFormId(this.edit.formid)

    this.reglaVal.pregsStore.pregsParaFormulario(this.edit.formid).then((pregsList) => {
      this.edit.busqueda.pregslist = pregsList

      this.edit.busqueda.resetCondiciones()

      this.$timeout(() => {
        let c = this.edit.busqueda.nuevaCondicionPregunta()

        if (rule?.idquestion) c.filterReqDocToWhere(rule)
      }, 100)
    })
  }
}

angular.module('candidato').component('reglaValidaReqDoc', {
  bindings: {
    reglaVal: '<',
  },
  controller: ReglaValidaReqDocComponentCtrl,
  // templateUrl: "regla-valida-req-doc.component.html",
  template: require('./regla-valida-req-doc.component.html'),
})
